import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { tomoCommonFeatures } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TomoCommonFeatures() {
  return <section className="border-y border-mp-border bg-mp-dark py-20 md:py-24" data-id="element-307" data-mp="7hlbevnoatc3">
      <Container data-id="element-308" data-mp="bl9lbkzs210i">
        <h2 className="mx-auto max-w-[750px] text-center font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl md:text-4xl" data-id="element-309" data-mp="binczj52bhh8">
          Cada tomo está diseñado para pasar de la teoría a la pista.
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-310" data-mp="qafhf03bjb46">
          {tomoCommonFeatures.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-6 text-center" data-id="element-311" data-mp="v7o4nf3bq5ca" data-mpi={i}>
              <p className="font-heading text-base uppercase tracking-wide text-mp-lime" data-id="element-312" data-mp="19sm7nrfo26bl">{item.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-313" data-mp="1oplcj7j4vl2d">{item.copy}</p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}